import { default as _91_46_46_46cms_93YzFk8jpdnzMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/[...cms].vue?macro=true";
import { default as _91_46_46_46slug_93OEhhoBiNzPMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/3d-projects/[...slug].vue?macro=true";
import { default as indexeHiHaalayJMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/3d-projects/index.vue?macro=true";
import { default as _91_46_46_46slug_93zKdbZw1zERMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/akcii/[...slug].vue?macro=true";
import { default as index52jQ7sQ50kMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/akcii/index.vue?macro=true";
import { default as _91_46_46_46slug_93UtRco0hJOwMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/articles/[...slug].vue?macro=true";
import { default as indexFgcfVYKzWpMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/articles/index.vue?macro=true";
import { default as indexoMprY9HgAeMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/authorization/index.vue?macro=true";
import { default as indexf4Gxv8Xcr3Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/cart/index.vue?macro=true";
import { default as _91_46_46_46id_93mjTih8ZEzhMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/cart/success/[...id].vue?macro=true";
import { default as _91_46_46_46slug_93C3Dq6YGALsMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/catalog/[...slug].vue?macro=true";
import { default as indexvWYx32dWcrMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/catalog/index.vue?macro=true";
import { default as _91_46_46_46slug_93AVpZmFNu8CMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/catalogsearch/[...slug].vue?macro=true";
import { default as resultyWGyXjCoteMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/catalogsearch/result.vue?macro=true";
import { default as index6t2noZNP2lMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/clear-page-slider/index.vue?macro=true";
import { default as _91_46_46_46slug_933Yu67x8L57Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/collection/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_93SPYETIROyLMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/fabriki/[...slug].vue?macro=true";
import { default as indexIWkyYLOgFWMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/fabriki/index.vue?macro=true";
import { default as _91_46_46_46slug_936wfrp0UGYoMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/product/[...slug].vue?macro=true";
import { default as indexaiGqP33WnoMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/profile/index.vue?macro=true";
import { default as indexmGibUjvzIIMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/profile/orders/index.vue?macro=true";
import { default as indexhugy6GecmtMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/recently/index.vue?macro=true";
import { default as _91_46_46_46slug_93IB515QV4I2Meta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/sets/[...slug].vue?macro=true";
import { default as index9zfy7jVX1rMeta } from "/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/wishlist/index.vue?macro=true";
export default [
  {
    name: _91_46_46_46cms_93YzFk8jpdnzMeta?.name ?? "cms",
    path: _91_46_46_46cms_93YzFk8jpdnzMeta?.path ?? "/:cms(.*)*",
    meta: _91_46_46_46cms_93YzFk8jpdnzMeta || {},
    alias: _91_46_46_46cms_93YzFk8jpdnzMeta?.alias || [],
    redirect: _91_46_46_46cms_93YzFk8jpdnzMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/[...cms].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93OEhhoBiNzPMeta?.name ?? "3d-projects-slug",
    path: _91_46_46_46slug_93OEhhoBiNzPMeta?.path ?? "/3d-projects/:slug(.*)*",
    meta: _91_46_46_46slug_93OEhhoBiNzPMeta || {},
    alias: _91_46_46_46slug_93OEhhoBiNzPMeta?.alias || [],
    redirect: _91_46_46_46slug_93OEhhoBiNzPMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/3d-projects/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexeHiHaalayJMeta?.name ?? "3d-projects",
    path: indexeHiHaalayJMeta?.path ?? "/3d-projects",
    meta: indexeHiHaalayJMeta || {},
    alias: indexeHiHaalayJMeta?.alias || [],
    redirect: indexeHiHaalayJMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/3d-projects/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93zKdbZw1zERMeta?.name ?? "akcii-slug",
    path: _91_46_46_46slug_93zKdbZw1zERMeta?.path ?? "/akcii/:slug(.*)*",
    meta: _91_46_46_46slug_93zKdbZw1zERMeta || {},
    alias: _91_46_46_46slug_93zKdbZw1zERMeta?.alias || [],
    redirect: _91_46_46_46slug_93zKdbZw1zERMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/akcii/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index52jQ7sQ50kMeta?.name ?? "akcii",
    path: index52jQ7sQ50kMeta?.path ?? "/akcii",
    meta: index52jQ7sQ50kMeta || {},
    alias: index52jQ7sQ50kMeta?.alias || [],
    redirect: index52jQ7sQ50kMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/akcii/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93UtRco0hJOwMeta?.name ?? "articles-slug",
    path: _91_46_46_46slug_93UtRco0hJOwMeta?.path ?? "/articles/:slug(.*)*",
    meta: _91_46_46_46slug_93UtRco0hJOwMeta || {},
    alias: _91_46_46_46slug_93UtRco0hJOwMeta?.alias || [],
    redirect: _91_46_46_46slug_93UtRco0hJOwMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/articles/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexFgcfVYKzWpMeta?.name ?? "articles",
    path: indexFgcfVYKzWpMeta?.path ?? "/articles",
    meta: indexFgcfVYKzWpMeta || {},
    alias: indexFgcfVYKzWpMeta?.alias || [],
    redirect: indexFgcfVYKzWpMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/articles/index.vue").then(m => m.default || m)
  },
  {
    name: indexoMprY9HgAeMeta?.name ?? "authorization",
    path: indexoMprY9HgAeMeta?.path ?? "/authorization",
    meta: indexoMprY9HgAeMeta || {},
    alias: indexoMprY9HgAeMeta?.alias || [],
    redirect: indexoMprY9HgAeMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/authorization/index.vue").then(m => m.default || m)
  },
  {
    name: indexf4Gxv8Xcr3Meta?.name ?? "cart",
    path: indexf4Gxv8Xcr3Meta?.path ?? "/cart",
    meta: indexf4Gxv8Xcr3Meta || {},
    alias: indexf4Gxv8Xcr3Meta?.alias || [],
    redirect: indexf4Gxv8Xcr3Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/cart/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46id_93mjTih8ZEzhMeta?.name ?? "cart-success-id",
    path: _91_46_46_46id_93mjTih8ZEzhMeta?.path ?? "/cart/success/:id(.*)*",
    meta: _91_46_46_46id_93mjTih8ZEzhMeta || {},
    alias: _91_46_46_46id_93mjTih8ZEzhMeta?.alias || [],
    redirect: _91_46_46_46id_93mjTih8ZEzhMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/cart/success/[...id].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93C3Dq6YGALsMeta?.name ?? "catalog-slug",
    path: _91_46_46_46slug_93C3Dq6YGALsMeta?.path ?? "/catalog/:slug(.*)*",
    meta: _91_46_46_46slug_93C3Dq6YGALsMeta || {},
    alias: _91_46_46_46slug_93C3Dq6YGALsMeta?.alias || [],
    redirect: _91_46_46_46slug_93C3Dq6YGALsMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/catalog/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexvWYx32dWcrMeta?.name ?? "catalog",
    path: indexvWYx32dWcrMeta?.path ?? "/catalog",
    meta: indexvWYx32dWcrMeta || {},
    alias: indexvWYx32dWcrMeta?.alias || [],
    redirect: indexvWYx32dWcrMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/catalog/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93AVpZmFNu8CMeta?.name ?? "catalogsearch-slug",
    path: _91_46_46_46slug_93AVpZmFNu8CMeta?.path ?? "/catalogsearch/:slug(.*)*",
    meta: _91_46_46_46slug_93AVpZmFNu8CMeta || {},
    alias: _91_46_46_46slug_93AVpZmFNu8CMeta?.alias || [],
    redirect: _91_46_46_46slug_93AVpZmFNu8CMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/catalogsearch/[...slug].vue").then(m => m.default || m)
  },
  {
    name: resultyWGyXjCoteMeta?.name ?? "catalogsearch-result",
    path: resultyWGyXjCoteMeta?.path ?? "/catalogsearch/result",
    meta: resultyWGyXjCoteMeta || {},
    alias: resultyWGyXjCoteMeta?.alias || [],
    redirect: resultyWGyXjCoteMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/catalogsearch/result.vue").then(m => m.default || m)
  },
  {
    name: index6t2noZNP2lMeta?.name ?? "clear-page-slider",
    path: index6t2noZNP2lMeta?.path ?? "/clear-page-slider",
    meta: index6t2noZNP2lMeta || {},
    alias: index6t2noZNP2lMeta?.alias || [],
    redirect: index6t2noZNP2lMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/clear-page-slider/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_933Yu67x8L57Meta?.name ?? "collection-slug",
    path: _91_46_46_46slug_933Yu67x8L57Meta?.path ?? "/collection/:slug(.*)*",
    meta: _91_46_46_46slug_933Yu67x8L57Meta || {},
    alias: _91_46_46_46slug_933Yu67x8L57Meta?.alias || [],
    redirect: _91_46_46_46slug_933Yu67x8L57Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/collection/[...slug].vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93SPYETIROyLMeta?.name ?? "fabriki-slug",
    path: _91_46_46_46slug_93SPYETIROyLMeta?.path ?? "/fabriki/:slug(.*)*",
    meta: _91_46_46_46slug_93SPYETIROyLMeta || {},
    alias: _91_46_46_46slug_93SPYETIROyLMeta?.alias || [],
    redirect: _91_46_46_46slug_93SPYETIROyLMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/fabriki/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexIWkyYLOgFWMeta?.name ?? "fabriki",
    path: indexIWkyYLOgFWMeta?.path ?? "/fabriki",
    meta: indexIWkyYLOgFWMeta || {},
    alias: indexIWkyYLOgFWMeta?.alias || [],
    redirect: indexIWkyYLOgFWMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/fabriki/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_936wfrp0UGYoMeta?.name ?? "product-slug",
    path: _91_46_46_46slug_936wfrp0UGYoMeta?.path ?? "/product/:slug(.*)*",
    meta: _91_46_46_46slug_936wfrp0UGYoMeta || {},
    alias: _91_46_46_46slug_936wfrp0UGYoMeta?.alias || [],
    redirect: _91_46_46_46slug_936wfrp0UGYoMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/product/[...slug].vue").then(m => m.default || m)
  },
  {
    name: indexaiGqP33WnoMeta?.name ?? "profile",
    path: indexaiGqP33WnoMeta?.path ?? "/profile",
    meta: indexaiGqP33WnoMeta || {},
    alias: indexaiGqP33WnoMeta?.alias || [],
    redirect: indexaiGqP33WnoMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/profile/index.vue").then(m => m.default || m)
  },
  {
    name: indexmGibUjvzIIMeta?.name ?? "profile-orders",
    path: indexmGibUjvzIIMeta?.path ?? "/profile/orders",
    meta: indexmGibUjvzIIMeta || {},
    alias: indexmGibUjvzIIMeta?.alias || [],
    redirect: indexmGibUjvzIIMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/profile/orders/index.vue").then(m => m.default || m)
  },
  {
    name: indexhugy6GecmtMeta?.name ?? "recently",
    path: indexhugy6GecmtMeta?.path ?? "/recently",
    meta: indexhugy6GecmtMeta || {},
    alias: indexhugy6GecmtMeta?.alias || [],
    redirect: indexhugy6GecmtMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/recently/index.vue").then(m => m.default || m)
  },
  {
    name: _91_46_46_46slug_93IB515QV4I2Meta?.name ?? "sets-slug",
    path: _91_46_46_46slug_93IB515QV4I2Meta?.path ?? "/sets/:slug(.*)*",
    meta: _91_46_46_46slug_93IB515QV4I2Meta || {},
    alias: _91_46_46_46slug_93IB515QV4I2Meta?.alias || [],
    redirect: _91_46_46_46slug_93IB515QV4I2Meta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/sets/[...slug].vue").then(m => m.default || m)
  },
  {
    name: index9zfy7jVX1rMeta?.name ?? "wishlist",
    path: index9zfy7jVX1rMeta?.path ?? "/wishlist",
    meta: index9zfy7jVX1rMeta || {},
    alias: index9zfy7jVX1rMeta?.alias || [],
    redirect: index9zfy7jVX1rMeta?.redirect,
    component: () => import("/var/www/new.mia-sofia.ru/miasofiaru-front-20260904120811/pages/wishlist/index.vue").then(m => m.default || m)
  }
]